import * as React from "react";
import AbstractLookup, { LookupConfigInterface } from "./AbstractLookup";
import { LookupInterface } from "./LookupInterface";

import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';

import Translator from "../../../Translation/Translator";
import Constants from "../../../Action/Constants";
import { CompanyInterface } from "../../../Entity/Entities/Company/CompanyInterface";
import { Owner } from "../../../Entity/Entities/Company/Type/Types/Owner";

class CompanyLookup extends AbstractLookup implements LookupInterface {
  protected componentRef: any;
  protected config: LookupConfigInterface = {
    entities: this.props.app.companies,
    type: Constants.LOOKUP_COMPONENT_COMPANY_CREATE_START,
    payloadPrefix: "company",
    entityTranslation: Translator.trans("dropdown-company-label"),
    disableEntityCreation: this.props.disableEntityCreation || false,
    floatingLabelText: this.props.floatingLabelText || Translator.trans("dropdown-searchforcompany-label"),
    labelText: this.props.labelText ? this.props.labelText : Translator.trans("dropdown-company-label"),
    buttonLabel: this.props.buttonLabel || Translator.trans("dropdown/company-button/newcompany"),
    dialogTitle: this.props.dialogTitle || Translator.trans("dropdown/company-button/newcompany"),
    dialogType: this.props.dialogType || Constants.LOOKUP_COMPONENT_DIALOG_TYPE_SMALL,
    visibilityProperty: "displayName",
    dialogInputToComponentSyncProperty: "name",
    componentState: {
      name: "",
      companyTypeId: Owner.companyTypeId
    },
    filter: this.props.filter || false,
    createPage: this.props.shouldOpenCoachModal ? "" : this.props.templateFor ? `/app/${this.props.templateFor}/create` : "/app/company/create",
    linkedObjectUrl: this.props.templateFor ? `/app/${this.props.templateFor}/update/` : "/app/company/update/",
    noResultText: this.props.noResultText || this.trans("dropdown-company-notfound"),
  };

  constructor(public props) {
    super(props);
  }

  public syncDialogValue(value: string): any {
    this.config.componentState.name = value;
    this.setState({
      name: value
    });
  }

  public deUmlaut(value){
    if (!value) {
      return "";
    }

    value = value.toLowerCase();
    value = value.replace(/ä/g, 'a');
    value = value.replace(/ö/g, 'o');
    value = value.replace(/ü/g, 'u');
    value = value.replace(/ß/g, 'ss');
    value = value.replace(/ /g, '-');
    value = value.replace(/\./g, '');
    value = value.replace(/,/g, '');
    value = value.replace(/\(/g, '');
    value = value.replace(/\)/g, '');

    return value;
  }

  public getList = (): any[] => {
    let list: CompanyInterface[] = this.getEntities()
      .filter((company: CompanyInterface) => {
        if (company.displayName && company.displayName.toLowerCase().includes(this.state.searchText && this.state.searchText.toLowerCase()) === true) {

          return true;
        } else {
          if (this.deUmlaut(company.displayName).toLowerCase().includes(this.state.searchText && this.state.searchText.toLowerCase()) === true) {

            return true;
          } else {
            let stringArr = this.state.searchText && this.state.searchText.toLocaleLowerCase().split(" ") || [];

            stringArr.map((string, index) => {
              if (index !== stringArr.length - 1) {
                return string + " ";
              }

              else {
                return string;
              };
            });

            let isIncluded = true;

            stringArr.forEach(string => {
              if (!(company.displayName && (company.displayName.toLowerCase() + " ").includes(string))) {
                isIncluded = false;
              }
            })

            if (isIncluded) {

              return true;
            } else {
              let isIncluded = true;

              stringArr.forEach(string => {
                if (!((this.deUmlaut(company.displayName).toLowerCase() + " ").includes(string))) {
                  isIncluded = false;
                }
              })

              if (isIncluded) {
                return true;
              }
            }
          }
        }
      })
      .sort((company1: CompanyInterface, company2: CompanyInterface) => {
        if (company1.name.toLowerCase() > company2.name.toLowerCase()) {
          return 1;
        }

        if (company1.name.toLowerCase() < company2.name.toLowerCase()) {
          return -1;
        }

        return  0;
      });

    return list.map((company: CompanyInterface, index: number) => {
      return (
        <ListItem
          key={index}
          onMouseDown={this.onSelect.bind(this, company)}
        >
          <ListItemAvatar>
            <Avatar className="avatar">
              {company.renderAvatar()}
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary={company.displayName}
            secondary={company.address && company.address.formattedAddress}
          />
        </ListItem>
      );
    });
  }

  public getEntities = (): CompanyInterface[]  => {
    if (Array.isArray(this.props.entitiesToSearch)) {
      return this.props.entitiesToSearch;
    } else {
      const companies = this.props.app.companies;
      return companies.filter(company => !!company)
        .filter(company =>
          {
            if(this.props.filterAgency) {
              return !company.isAgency;
            } else {
              return !!company
            }
            })
        .filter((company: CompanyInterface) => {
          return company.removed === false || (company.removed === true && !!this.props.autoSelectId && company.id === this.props.autoSelectId);
      })
      .filter((company: CompanyInterface) => {
        // Filter companies out that are not owners
        return this.props.filterOwner ? company.isOwner : company
      })
    }
  }

  public getPayloadFromComponent(): any {
    return {};
  }
}

export default CompanyLookup;
